import * as a from "comlink";
import n from "./CacheableTile.js";
import { WarpedMapEvent as o, WarpedMapEventType as i } from "../shared/events.js";
class s extends n {
  /**
   * Fetch the tile and create its ImageData using a WebWorker.
   *
   * @async
   * @returns {Promise<void>}
   */
  async fetch() {
    try {
      const e = new Worker(
        new URL(
          /* @vite-ignore */
          "" + new URL("../assets/fetch-and-get-image-data-C4SLzSd4.js", import.meta.url).href,
          import.meta.url
        )
      );
      a.wrap(e).getImageData(
        this.tileUrl,
        a.proxy(() => this.abortController.abort()),
        this.fetchFn,
        this.tile.tileZoomLevel.width,
        this.tile.tileZoomLevel.height
      ).then((t) => {
        this.data = t, this.dispatchEvent(
          new o(i.TILEFETCHED, this.tileUrl)
        ), e.terminate();
      }).catch((t) => {
        t instanceof Error && t.name === "AbortError" ? console.log("Fetch aborted") : console.error(t), e.terminate();
      });
    } catch (e) {
      e instanceof Error && e.name === "AbortError" || this.dispatchEvent(
        new o(i.TILEFETCHERROR, this.tileUrl)
      );
    }
    return this.data;
  }
  static createFactory() {
    return (e, r) => new s(e, r);
  }
}
export {
  s as default
};
//# sourceMappingURL=CacheableWorkerImageDataTile.js.map
